/**
 * Max loss basis points for yearn withdrawals
 * If 0, the contract's default max loss basis points will be used
 */
export const MAX_LOSS_BASIS_POINTS = 0
/**
 * Flag specifying whether to override the max loss basis points for yearn withdrawals
 */
export const OVERRIDE_MAX_LOSS = false
